<template>
  <div class="disputed-orders__empty glass-card">
    <div class="empty-icon">✓</div>
    <h3>No disputed orders found</h3>
    <p>All disputes have been resolved or no disputes exist.</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState'
}
</script>

<style scoped>
.disputed-orders__empty {
  text-align: center;
  padding: 80px 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.disputed-orders__empty h3 {
  font-size: 20px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 8px;
}

.disputed-orders__empty p {
  font-size: 14px;
  color: #64748b;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/EmptyState.vue